import DatePicker from 'vue2-datepicker';
// import custom from '@/f1/custom';
import codes from '@/f1/codes';
import { api } from '@/f1/service';
import punycode from 'punycode';
import { Switch as cSwitch } from '@coreui/vue';
import _ from 'lodash';
import reg from '@/f1/reg';
import { VclFacebook } from 'vue-content-loading';
// TODO
// 1. 건바이건으로 해야함
// 2. UX 고려하여 진행사항 표시하는 것으로 변경
// 3. 사이트 생성시 확인 사항이 많아서 이게 최선임
import Language from './language';

//restful api
//import { wmds as ws } from '@/f1/service/api'

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components : { DatePicker, cSwitch, VclFacebook, Language },
  name : "UploadCSV",
  props: [],
  watch: {},
  data: () => ({
    modal_charge_agree : false,
    stop : false,
    options : [{ text : 'URL', value : 1 }, { text : 'Sub Domain', value : 2 }, { text : 'Exception Path', value : 3 }],
    sel : [],
    progress : { done : 0, error : 0, },
    loading : false,
    so : Object.assign({}, codes.DEFAULT_OPT, { skt : 'FQDN', sv : '' }),
    file : {},
    file_data : "",
    base_href : location.hostname == 'localhost' ? 'https://api.f1secaas.net' : `${location.protocol}//${location.hostname.replace(/^[^\\.]*\./, 'api.')}`,
    sites : [],
    // fields_data : 
    // [
    //   { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%', option : 0 },
    //   { key: 'is_alive', label: 'Status', sortable: false, thStyle: 'width: 10%', option : 0 },
    //   { key: 'is_start', label: 'Inspection at registration', sortable: false, thStyle: 'width: 10%', option : 0 },
    //   { key: 'name', label: 'Name', sortable: false, option : 0 },
    //   { key: 'fqdn', label: 'FQDN', sortable: false, option : 0 },
    //   { key: 'schedule', label: 'Schedule', sortable: true, option : 0 },
    //   { key: 'policy', label: 'Policy Name', sortable: true, option : 0 },
    //   { key: 'seeds', label: 'URL', sortable: true, option : 1 },
    //   { key: 'subs', label: 'Sub Domain', sortable: true, option : 2 }, // option 임
    //   { key: 'prevents', label: 'Exception Path', sortable: true, option : 3 }, // option 임
    //   { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%' , option : 0 },
    // ],
    // fields_data_ko : [
    //   { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%', option : 0 },
    //   { key: 'is_alive', label: '상태', sortable: false, thStyle: 'width: 10%', option : 0 },
    //   { key: 'is_start', label: '등록과 동시 시작', sortable: false, thStyle: 'width: 10%', option : 0 },
    //   { key: 'name', label: '이름', sortable: false, option : 0 },
    //   { key: 'fqdn', label: 'FQDN', sortable: false, option : 0 },
    //   { key: 'schedule', label: '일정', sortable: true, option : 0 },
    //   { key: 'policy', label: '정책이름', sortable: true, option : 0 },
    //   { key: 'seeds', label: 'URL', sortable: true, option : 1 },
    //   { key: 'subs', label: '서브도메인', sortable: true, option : 2 }, // option 임
    //   { key: 'prevents', label: '예외경로', sortable: true, option : 3 }, // option 임
    //   { key: 'func', label: '기능', sortable: false, thStyle: 'width: 10%' , option : 0 },
    // ]
  }),
  computed: {
    // i18n_data() { return _i18n_data },
    // redir() {
    //   // console.log(`${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.net' : location.hostname.replace('console.', 'www')}/ToS`)
    //   return `${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.net' : location.hostname.replace('console.', 'www.')}/ToS`
    // },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    rowCount: function() { return this.so.totalRows || 0; },
    fields() {
      // return _.map(this.fields_data, f => {
      //   if(_.indexOf(this.sel, f.option) > -1 || f.option < 1) {
      //     return f
      //   }
      // })
      return _.map(_i18n_data.fields_data[this.i18n], f => {
        if(_.indexOf(this.sel, f.option) > -1 || f.option < 1) {
          return f
        }
      })
    }
  },
  methods: {
    field_add(m) {
      const idx = this.sel.indexOf(m);
      if (idx > -1) this.sel.splice(idx, 1);
      else this.sel.push(m)
      return;
    },
    async charge_agree() {
      try {
        let rs = await api.wmds.WMDS_Call('site', 'agree', { ts : new Date().getTime() });
        //let rs = await ws.site.agree({ ts : new Date().getTime() });
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.agreement_failed[this.i18n]}`) }
        // 시스템 로그가 남아야 함, 동의 부분 관련
        this.download_sample()
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.agreement_failed[this.i18n]}`) }

    },
    download_sample: function() { window.open('https://secaas-download.s3.ap-northeast-2.amazonaws.com/dist/WMDS/v1/WMDS_site_upload_format_sample.csv', '_blank') },
    selected(file) {
      try {
        if(!file || (file && !file.name)) { return console.log("no have file") }
        let local = this;
        let reader = new FileReader();
        reader.onload = () => {
          local.file_data = reader.result.split('\n')
          local.csv_parser(local.file_data)
        }
        reader.readAsText(file);
      } catch (e) { console.log(e) }
    },
    csv_parser(data) {
      // console.log(data)
      if(data.length < 3) { return this.$toastr.e(`${_i18n_data._i18n_error.csv_parser[this.i18n]}`) }

      // "Name", "FQDN", "Check_Start_URL", "Schedule(by cron)", "Sub_Domain", "Exception_Path"
      let sites = data.slice(2, data.length)
      sites.forEach(site => {
        let s = site.split(',')
        if(_.compact(s).length < 5) { return console.log('no have a row') }

        this.sites.push({
          is_done : false,
          is_alive : true,
          is_start : false,
          name : s[0],
          fqdn : this.check_kr(s[1]),
          seeds : _.compact(_.map(s[2].split(';'), x => this.check_kr(x))),
          schedule : _.compact(s[3].split(';')),
          subs : _.compact(_.map(s[4].split(';'), x => this.check_kr(x))), // 한글 서브 도메인 지원
          prevents : _.compact(s[5].split(';')),
          policy : (s[6] || '').trim(),
        })
      });
      this.refresh()
    },
    check_kr(domain) {
      // 한글 도메인 등록
      if(domain && /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(domain)){
        let d = domain.split('://')
        return (d.length > 1 ? d[0]+'://' : '' ) + punycode.toASCII(d.length > 1 ? d[1] : d[0])
      }
      return domain
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.sites = []; this.file = {}; this.progress = { error : 0, done : 0 }; this.$refs.file_input.reset(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); this.change_to_disable = []; this.change_to_enable = []; this.$toastr.i(`${i18n_data._i18n_success.refresh[this.i18n]}`) },
    getItems: function(ctx) { return this.load(ctx); },
    load() {
      let offset = (this.so.currentPage-1 || 0) * Number(this.so.perPage)
      let limit = offset + Number(this.so.perPage)
      let list = [];

      if(this.so.sv) {  list = this.so.skt == 'FQDN' ? _.filter(this.sites, s => s.fqdn.indexOf(this.so.sv) > -1) : _.filter(this.sites, s => s.name.indexOf(this.so.sv) > -1)}
      else { list = this.sites }
      this.so.totalRows = list.length
      console.log('slice', offset, limit, this.sites.length, 'return', list.slice(offset, limit).length)
      return list.slice(offset, limit)
    },
    toggle(type) {
      let offset = (this.so.currentPage-1 || 0) * Number(this.so.perPage)
      let limit = offset + Number(this.so.perPage)
      console.log('toggle', 'offset', offset, 'limit', limit)
      // console.log('slice', offset, limit, this.sites.length)
      this.sites.forEach((s, index) => {
        if(index >=  offset && index < limit) {
          s.is_start = type == 'is_start' ? !s.is_start : s.is_start
          s.is_alive = type == 'is_alive' ? !s.is_alive : s.is_alive
        }
      })
      this.refresh()
    },
    clear_done() {
      this.sites = _.filter(this.sites, s => !s.is_done & !s.is_error)
      this.refresh()
    },
    async upload_multi(only_page = false) {
      if(this.sites.length < 1) { return this.$toastr.w(`${i18n_data._i18n_warning.data_check[this.i18n]}`) }
      this.loading = true
      let offset = (this.so.currentPage-1 || 0) * Number(this.so.perPage)
      let limit = offset + Number(this.so.perPage)

      for (let origin_index = 0; origin_index < this.sites.length; origin_index++) {
        if(this.stop) { break }

        // console.log(only_page, "test", origin_index,  offset, origin_index, limit)
        if(only_page && !(origin_index >=  offset && origin_index < limit)) { continue }

        if(this.sites[origin_index].is_done) {
          console.log('already complated ' + this.sites[origin_index].fqdn);
          this.$toastr.w(`${_i18n_data._i18n_warning.complated[this.i18n]}` + this.sites[origin_index].fqdn)
          continue
        }
        let rs = await this.upload_one(origin_index)
        if(rs) { this.progress.done += 1 }
        else { this.progress.error += 1 }
        console.log(this.sites[origin_index].fqdn, rs)
      }
      if(this.stop) { this.stop = false; this.$toastr.w(`${_i18n_data._i18n_error.stopped[this.i18n]}`) }
      setTimeout(() => this.loading = false, 3 * 1000)
    },
    async upload_one(origin_index) {
      let s = this.sites[origin_index]

      if(!s.name || s.name.length < 1) {  this.sites[origin_index] = Object.assign({}, this.sites[origin_index], { msg : `${_i18n_data._i18n_msg.site_name[this.i18n]}`, is_done : true, is_error : true }); }
      if(!s.policy || s.policy.length < 1) {  this.sites[origin_index] = Object.assign({}, this.sites[origin_index], { msg : `${_i18n_data._i18n_msg.policy_name[this.i18n]}`, is_done : true, is_error : true }); }
      if(!s.fqdn || s.fqdn.length < 1) {  this.sites[origin_index] = Object.assign({}, this.sites[origin_index], { msg : `${_i18n_data._i18n_msg.fqdn_name[this.i18n]}`, is_done : true, is_error : true }); }
      if(!s.schedule || s.schedule.length < 1) {  this.sites[origin_index] = Object.assign({}, this.sites[origin_index], { msg : `${_i18n_data._i18n_msg.schedule_name[this.i18n]}`, is_done : true, is_error : true }); }
      if(!s.seeds || s.seeds.length < 1) {  this.sites[origin_index] = Object.assign({}, this.sites[origin_index], { msg : `${_i18n_data._i18n_msg.start_URL[this.i18n]}`, is_done : true, is_error : true }); }
      // option
      // if(!site.subs || site.subs.length < 1) { return this.sites[origin_index].msg = "no have sub domain" }
      // if(!site.prevents || site.prevents.length < 1) { return this.sites[origin_index].msg = "no have exception path" }
      if(reg.prevent_domain.test(punycode.toASCII(s.fqdn))) { return this.sites[origin_index].msg = "Domain Type Check"; }

      let site  = {
        policy : s.policy.replace('\r\n', ''),
        seeds : _.map(s.seeds, x => x.replace('/r', '')),
        schedule : _.map(s.schedule, x => x.replace('/r', '')),
        prevents : _.map(s.prevents, x => x.replace('/r', '')),
        subs : _.map(s.subs, x => x.replace('/r', '')),
        fqdn : s.fqdn,
        name : s.name,
        is_alive : s.is_alive,
        is_start : s.is_start,
      }
      try {
        // 업로드 시도
        // insert.upload.list 메소드도 있으나, 작업이 많아서 한번에 하기가 빡셈, 일단 구현 후 나중에 속도를 고려하여 개선하는 것으로 해야함 다른 할일이 너무 많음
        let rs = await api.wmds.WMDS_Call('site', 'insert.upload.one', site);
        //let rs = await ws.site.uploadOne(site);
        this.sites[origin_index].is_done = true
        if(!rs.error) { this.$toastr.s(`${site.fqdn} ` + `${i18n_data._i18n_success.saved[this.i18n]}`) }
        else {
          this.sites[origin_index].is_error = true
          this.sites[origin_index].msg = rs.reason
        }

      } catch(e) { this.sites[origin_index].msg = e.data.message; this.sites[origin_index].is_error = this.sites[origin_index].is_done = true }
      if(this.sites[origin_index].is_error) { this.$toastr.e(`${site.fqdn} ` + `${i18n_data._i18n_error.upload_failed[this.i18n]}`) }
      // 업로드 성공 여부를 리턴
      return this.sites[origin_index].is_error ? false : true
    },
    list: function() { this.$router.push({ name : 'wmds_site' }) },
  },
  created: function() {   console.log('site.list.vue', 'created'); },
  destroyed: function() { console.log('site.list.vue', 'destroyed'); },
  mounted: function() { console.log('site.list.vue', 'mounted'); },
}
